import React from 'react';
import { PaymentMethod } from '@wix/cashier-common/dist/src/enums/payments/PaymentMethod';
import { PaymentProvider } from '@wix/cashier-common/dist/src/enums/payments/PaymentProvider';
import { getPageFingerprint } from '../../../utils/sentry/getPageFingerprint';
import { amountToLong } from '../../../utils/amountToLong';
import { decorateGetInitialPaymentDataWithBi } from '../../../services/applePay/decorateGetInitialPaymentDataWithBi';
import { applePayButtonRendered, expressCheckoutWidgetButtonClicked } from '../../../utils/bi/events/applePay';
import { Props } from './controller.connect';
import { ApplePayView } from './view';

export class ApplePayController extends React.Component<Props> {
  componentDidMount() {
    const { meta, requestShipping, currency, paymentAmount } = this.props.topProps;
    this.props.biLogger.report(
      applePayButtonRendered({
        pageType: getPageFingerprint(),
        cartId: meta.cartId,
        msid: meta.siteId,
        paymentmethod: PaymentMethod.ApplePay,
        paymentProvider: PaymentProvider.WixPayUS,
        requestShipping,
        visitorId: meta.visitorId,
        currency,
        amount: amountToLong(paymentAmount),
      }),
    );
  }

  onClick = () => {
    const {
      paymentAmount,
      paymentLabel,
      currency,
      requestShipping,
      shippingMethods,
      paymentBreakdown,
      meta,
      domain,
      onShippingContactSelected,
      onShippingMethodSelected,
      onPaymentAuthorized,
      getInitialPaymentData,
    } = this.props.topProps;

    this.props.biLogger.report(
      expressCheckoutWidgetButtonClicked({
        amountLong: amountToLong(paymentAmount),
        amount: amountToLong(paymentAmount),
        appInstanceId: meta.appInstanceId,
        currency,
        paymentProvider: PaymentProvider.WixPayUS,
        paymentmethod: PaymentMethod.ApplePay,
        productId: meta.productId,
        origin: 'product',
      }),
    );
    this.props.startApplePayFlow({
      ...this.props,
      meta,
      sessionId: this.props.sessionId,
      paymentAmount,
      paymentLabel,
      currencyCode: currency,
      requestShipping,
      shippingMethods,
      paymentBreakdown,
      domain,
      onShippingContactSelected,
      onShippingMethodSelected,
      onPaymentAuthorized,
      getInitialPaymentDataWithBi: decorateGetInitialPaymentDataWithBi({
        biLogger: this.props.biLogger,
        cb: getInitialPaymentData,
        data: { appInstanceId: meta.appInstanceId, currencyCode: currency, paymentLabel },
      }),
    });
  };

  render() {
    return (
      <ApplePayView
        height={this.props.topProps.buttonStyle.height}
        locale={this.props.topProps.locale}
        color={this.props.color}
        shape={this.props.topProps.buttonStyle.shape}
        onClick={this.onClick}
      ></ApplePayView>
    );
  }
}
